import { bnPageHead } from "@/lib/bn-head";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Section } from "@/components/Section";
import { PricingNotFor, PricingTierGrid } from "@/components/pricing/PricingTierGrid";
import { JsonLd } from "@/components/JsonLd";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { FaqAccordion } from "@/components/FaqAccordion";
import { SITE } from "@/content/site";
import { BN_PRICING_TIERS, BN_NOT_FOR, BN_PRICING_FAQS } from "@/content/bn/pricing";

const TITLE = "এসইও, AEO ও GEO প্যাকেজ ও দাম (২০২৬) | ফ্রিল্যান্সার তামাল";
const DESC =
  "বাংলাদেশে এসইও, AEO ও GEO সার্ভিসের স্বচ্ছ দাম: টেকনিক্যাল অডিট ৳২০,০০০–৳৫০,০০০, লোকাল এসইও ৳১৫,০০০–৳৩৫,০০০/মাস, AEO স্প্রিন্ট ৳২৫,০০০–৳৬০,০০০, GEO রিটেইনার ৳৩০,০০০–৳৭০,০০০/মাস।";

export const Route = createFileRoute("/bn/pricing")({
  head: () =>
    bnPageHead({
      path: "/bn/pricing",
      enPath: "/pricing",
      title: TITLE,
      desc: DESC,
      keywords: ["এসইও প্যাকেজ দাম", "এসইও সার্ভিস খরচ", "মাসিক এসইও প্যাকেজ", "লোকাল এসইও দাম"],
      suffix: false,
    }),
  component: BnPricingPage,
});

function BnPricingPage() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE.url}/bn/pricing#service`,
    name: "এসইও, AEO ও GEO কনসাল্টিং",
    serviceType: "Search Engine Optimization",
    areaServed: "Bangladesh",
    inLanguage: "bn",
    provider: {
      "@type": "Person",
      "@id": `${SITE.url}/#person`,
      name: SITE.fullName,
      url: `${SITE.url}/about`,
    },
    offers: BN_PRICING_TIERS.map((t) => ({
      "@type": "Offer",
      "@id": `${SITE.url}/bn/pricing#${t.slug}`,
      name: t.name,
      description: t.summary,
      priceCurrency: "BDT",
      category: t.cadence,
      availability: "https://schema.org/InStock",
      url: `${SITE.url}/bn/pricing#${t.slug}`,
    })),
  };

  return (
    <>
      <Breadcrumbs
        items={[
          { name: "হোম", path: "/bn" },
          { name: "সার্ভিস", path: "/bn/services" },
          { name: "প্যাকেজ ও দাম", path: "/bn/pricing" },
        ]}
      />
      <h1 className="sr-only">এসইও প্যাকেজ ও দাম</h1>
      <JsonLd data={schema} />

      <Section
        eyebrow="প্যাকেজ"
        title={
          <>
            কাজের <span className="text-gradient">আসল খরচ কত।</span>
          </>
        }
      >
        <p className="max-w-2xl text-lg text-muted-foreground -mt-8">
          কোট চাওয়ার আগেই দামগুলো এখানে লেখা আছে। বাংলাদেশি ব্যবসার জন্য টাকায়,
          আন্তর্জাতিক ক্লায়েন্টের জন্য{" "}
          <Link to="/pricing" className="underline underline-offset-4 hover:text-primary">
            ডলারের পাতায়
          </Link>
          ।
        </p>
      </Section>

      <PricingTierGrid tiers={BN_PRICING_TIERS} variant="bn" />

      <Section eyebrow="সততা আগে" title="কখন আমি নিজেই না বলব।">
        <PricingNotFor
          items={BN_NOT_FOR}
          variant="bn"
          bookLabel="২০ মিনিটের ফ্রি কল বুক করুন"
          contactLabel="ইমেইলে যোগাযোগ"
        />
      </Section>

      <Section eyebrow="প্রশ্নোত্তর" title="দাম নিয়ে সাধারণ প্রশ্ন।">
        <FaqAccordion items={BN_PRICING_FAQS} idPrefix="faq-bn-pricing" />
      </Section>
    </>
  );
}
